(
    function (skyward, $, undefined)
    {
        skyward.courserequest = skyward.courserequest || {};

        var availableCoursesContains = '#AvailableCoursesContains';
        var maximumCredits = '.js-onlineRequestsMaximumCredits';
        var maximumAlternateCredits = '.js-onlineRequestsMaximumAlternateCredits';
        var maximumCourseRequests = '.js-onlineRequestsMaximumCourseRequests';
        var maximumAlternateCourseRequests = '.js-onlineRequestsMaximumAlternateCourseRequests';
        var totalEarnedCredits = '.js-onlineRequestsTotalEarnedCredits';
        var totalAlternateEarnedCredits = '.js-onlineRequestsTotalAlternateEarnedCredits';
        var totalRequests = '.js-onlineRequestsTotalRequests';
        var totalAlternateRequests = '.js-onlineRequestsTotalAlternateRequests';

        var availableCoursesBrowseName = 'AvailabilityListCourses';
        var selectedCoursesBrowseName = 'StudentCourseRequestsSelected';
        var alternateCourseBrowseName = 'AlternateStudentCourseRequestsSelected';
        var courseRequestContentAreaName = 'CourseRequestContentArea';
        var alternateReorderName = "AlternateReorder";

        var courseIDName = "CourseID";
        var courseCodeName = "CourseCode";
        var courseDescriptionName = "Description";
        var courseCodeDescriptionName = "CodeDescription";
        var studentCourseRequestIDName = "StudentCourseRequestID";
        var requestSourceCodeName = "RequestSourceCode";
        var requestStatusCodeName = "RequestStatusCode";
        var rankName = "AlternateRank";

        var isAlternateTabName = "Alternates";

        var linkedAlternatesName = "LinkedAlternates";
        var initialLinkedAlternatesName = "InitialLinkedAlternates";
        var linkedAlternatesUpdatedName = "LinkedAlternatesUpdated";

        //static should not change once it is set
        var accessMode;
        var entityID;
        var schoolYearID;
        var studentID;
        var entityID_securityhash;
        var schoolYearID_securityhash;
        var studentID_securityhash;
        var availabilityFilterCourseStudentID;
        var availabilityFilterCourseStudentID_securityhash;
        var initialAlternateStudentCourseRequestRank = "";
        var useCourseRequestCountMaximum;
        var useCreditsMaximum;

        //course request lists
        var alternateStudentCourseRequestIDsToRemove = "";
        var alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        var alternateCourseIDsToAdd = "";
        var alternateCourseIDsToAddSecurityHash = "";
        var alternatesRank = "";

        var studentCourseRequestIDsToRemove = "";
        var studentCourseRequestIDsToRemoveSecurityHash = "";
        var courseIDsToAdd = "";
        var courseIDsToAddSecurityHash = "";

        var isAlternateMode = false;
        var requestContentMessageArea;
        var myRequestsPopupRequestContentMessageArea;
        var submitButton;
        var cancelButton;
        var reorderButton;
        var availableCoursesElement;
        var selectedCoursesElement;
        var alternateCourseElement;

        var previousContainsString = '';

        var reorderElement;
        var reorderColumnWidths = [40, 150, 85, 150]; //as specified in StudentCourseRequestController.GetSortable(), but with Code and
        //Description swapped to match the order they appear in Online Requests browses, plus Alternate For (linked course)

        var init = function (selector)
        {
            if (selector == "#" + selectedCoursesBrowseName)
            {
                selectedCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + availableCoursesBrowseName)
            {
                availableCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateCourseBrowseName)
            {
                alternateCourseElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateReorderName)
            {
                reorderElement = $(selector);
            }
        };

        var browseInitialLoad = true;
        var browseRowChanged = function (browse)
        {
            if (!browse || !browse.body || !browse.body.find)
            {
                return;
            }
            browse.body.find(".browseRow.current .button").focus();
        };

        //initialization functions
        var initBrowseSearchControls = function ()
        {
            $("#SearchDiv").find('.courseRequestBrowseSearch').each(function ()
            {
                var browseSearch = $(this);
                var browseSearchBox = browseSearch.children('.courseRequestSearchTextbox');

                browseSearchBox.focus(function ()
                {
                    browseSearch.addClass('simulateFocus');
                });

                browseSearch.focusout(function ()
                {
                    browseSearch.removeClass('simulateFocus');
                });
            });
        };

        var initTabButtonHandlers = function ()
        {
            $("#RequestedCourseWrapper").on("tabClicked", ".js-tabbedContainerButton", tabClickHandler);
        };

        var generateCourseFilter = function ()
        {
            skyward.courserequest.generateCourseFilter();
        };

        var mainSelectedBrowseUpdated = function ()
        {
            var mainSelectedBrowseClassName = "mainSelectedBrowse";
            if (alternateCourseElement)
            {
                alternateCourseElement.addClass(mainSelectedBrowseClassName);
            }

            if (selectedCoursesElement)
            {
                selectedCoursesElement.addClass(mainSelectedBrowseClassName);
            }

            if (availableCoursesElement)
            {
                availableCoursesElement.addClass(mainSelectedBrowseClassName);
            }
        };

        var initializationComplete = false;
        skyward.courserequest.initializeOnlineCourseRequest = function ()
        {
            if (initializationComplete)
            {
                return;
            }

            initializationComplete = true;
            initializeMode();

            skyward.browse.eventCallbacks.updateActiveBrowseClasses.registerCallback(mainSelectedBrowseUpdated);

            var body = $("body");
            body.off("browseLoaded." + selectedCoursesBrowseName).on("browseLoaded." + selectedCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + availableCoursesBrowseName).on("browseLoaded." + availableCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + alternateCourseBrowseName).on("browseLoaded." + alternateCourseBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });

            submitButton = $('.js-onlineRequestsSubmit,.js-onlineRequestsSubmitAndReview');
            cancelButton = $('.js-onlineRequestsCancel');

            $("#" + selectedCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + availableCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + alternateCourseBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            skyward.courserequest.setStaticVariables();
            initBrowseSearchControls();
            initTabButtonHandlers();
            requestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-courserequestcontentmessageareawrapper"));
            myRequestsPopupRequestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-myrequestspopupcourserequestcontentmessageareawrapper").parent());

            skyward.courserequest.hookupButtonEvents();
            showHideToolBarButtons();
            refreshSelectedBrowseTotals();
            $('.courseRequestSearchTextbox').keydown(skyward.debounce(generateCourseFilter, 600));
            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var searchFocusAndSelectText = function ()
        {
            $(availableCoursesContains).focus().select();
        };

        var initializeMode = function ()
        {
            reorderButton = $('#ReorderAlternates');
            isAlternateMode = $(".tabbedContent__tabButton-current:contains('" + isAlternateTabName + "')").length > 0;
        };

        skyward.courserequest.hookupButtonEvents = function ()
        {
            $("body").off('click', skyward.courserequest.submitCourseRequest).on('click', ".js-onlineRequestsSubmit", null, skyward.courserequest.submitCourseRequest);
            cancelButton.off('click', skyward.courserequest.cancel).on('click', skyward.courserequest.cancel);
            reorderButton.off('click', skyward.courserequest.reorder).on('click', skyward.courserequest.reorder);
            $("body").off("click", requestCourseRowButtonClick).on("click", ".js-requestCourseAddButton", null, requestCourseRowButtonClick);
            $("body").off("click", removeRequestedCourseRowButtonClick).on("click", ".js-requestCourseRemoveButton", null, removeRequestedCourseRowButtonClick);
            $("body").off("click", showPrimaryAlternatePopupButtonClick).on("click", ".js-requestCoursePrimaryAlternatePopup", null, showPrimaryAlternatePopupButtonClick);
            $("body").off("click", showAlternateInfoPopupButtonClick).on("click", ".js-requestCourseAlternateInfoButton", null, showAlternateInfoPopupButtonClick);
            $("#" + courseRequestContentAreaName).off("click", showMyRequestsButtonClick).on("click", ".js-onlineRequestsViewMyRequests", null, showMyRequestsButtonClick);
            $("#" + courseRequestContentAreaName).off("click", submitAndReviewButtonClick).on("click", ".js-onlineRequestsSubmitAndReview", null, submitAndReviewButtonClick);

            // Attach onchange event to CourseAlt EEL elements
            initCourseAltEELChangeHandlers();
        };

        skyward.courserequest.setStaticVariables = function ()
        {
            var courseRequestContainer = $("#" + courseRequestContentAreaName);
            entityID = courseRequestContainer.data('entityid');
            studentID = courseRequestContainer.data('studentid');
            schoolYearID = courseRequestContainer.data('schoolyearid');
            accessMode = courseRequestContainer.data('accessmode');
            entityID_securityhash = courseRequestContainer.data('entityid_securityhash');
            schoolYearID_securityhash = courseRequestContainer.data('schoolyearid_securityhash');
            studentID_securityhash = courseRequestContainer.data('studentid_securityhash');
            availabilityFilterCourseStudentID = courseRequestContainer.data('availabilityfiltercoursestudentid');
            availabilityFilterCourseStudentID_securityhash = courseRequestContainer.data('availabilityfiltercoursestudentid_securityhash');
            updateInitialAlternateRank(JSON.stringify(courseRequestContainer.data('initial-alternate-rank')));
        };

        //button functions
        var requestCourse = function (courseID, courseIDSecurityHash)
        {
            resetMessages();

            var linkedAlternates = getLinkedAlternates();

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select an Available Course to Add");
                return;
            }

            var maximumCreditsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCredits) : getRequestOrCreditsValue(maximumCredits);
            var maximumRequestsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCourseRequests) : getRequestOrCreditsValue(maximumCourseRequests);

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RequestCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    MaximumCredits: maximumCreditsValue,
                    MaximumCourseRequests: maximumRequestsValue,
                    UseCreditsMaximum: useCreditsMaximum,
                    UseCourseRequestCountMaximum: useCourseRequestCountMaximum,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RequestCourse", data, courseID, isAlternateMode);
                }
            });
        };

        function getDataFromRow(button)
        {
            const rowId = button.parents("td").data("row");
            const browseName = button.parents(".browse").attr("id");
            const browse = skyward.browse.browseList[browseName];

            if (!browse || rowId === undefined)
            {
                return {};
            }

            const data = 
            {
                CourseID: browse.rowData[rowId]["CourseID"],
                CourseIDSecurityHash: browse.rowData[rowId]["CourseIDSecurityHash"]
            };

            if (browse.rowData[rowId][studentCourseRequestIDName] && browse.rowData[rowId]["StudentCourseRequestIDSecurityHash"])
            {
                const studentCourseRequestID = browse.rowData[rowId][studentCourseRequestIDName];

                if (studentCourseRequestID !== undefined)
                {
                    data.StudentCourseRequestID = studentCourseRequestID;
                    data.StudentCourseRequestIDSecurityHash = browse.rowData[rowId]["StudentCourseRequestIDSecurityHash"];
                }
            }

            setPropertyIfRowDataPresent(requestStatusCodeName, "RequestStatus");
            setPropertyIfRowDataPresent(requestSourceCodeName, "RequestSource");

            setPropertyIfRowDataPresent("CodeDescription", "CodeDescription");
            setPropertyIfRowDataPresent("CourseCode", "CourseCode");
            setPropertyIfRowDataPresent("Description", "Description");
            setPropertyIfRowDataPresent("EarnedCredits", "EarnedCredits");
            setPropertyIfRowDataPresent("Subject.Description", "Subject");
            setPropertyIfRowDataPresent("CourseIDAlternateFor", "CourseIDAlternateFor");
            setPropertyIfRowDataPresent("StudentCourseRequestID", "StudentCourseRequestID");
            setPropertyIfRowDataPresent("IsReadOnly", "IsReadOnly");
            if (browse.rowData[rowId]["IsAlternate"])
            {
                data["IsAlternate"] = (browse.rowData[rowId]["IsAlternate"] || "").toLowerCase() === "true";
            }

            return data;

            function setPropertyIfRowDataPresent(rowDataName, propertyToSet)
            {
                if (browse.rowData[rowId][rowDataName])
                {
                    data[propertyToSet] = browse.rowData[rowId][rowDataName];
                }
            }
        }

        var requestCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            requestCourse(rowData.CourseID, rowData.CourseIDSecurityHash);
        };

        var postRequestRemoveCourse = function (action, data, courseID, isAlternateMode)
        {
            if (data.warningmessage != "" && data.warningmessage != null && data.warningmessage != "undefined")
            {
                skyward.courserequest.showWarning(data.warningmessage);
            }

            if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
            {
                skyward.courserequest.showError(data.errormessage);
                return;
            }

            updateStudentCourseRequestIDsToRemoveList(data);
            updateCourseIDsToAddList(data);

            if (data.totalearnedcredits != "")
            {
                setRequestOrCreditsText(totalEarnedCredits, data.totalearnedcredits);
            }

            if (data.totalrequests != "")
            {
                setRequestOrCreditsText(totalRequests, data.totalrequests);
            }

            if (data.totalalternateearnedcredits != "") {
                setRequestOrCreditsText(totalAlternateEarnedCredits, data.totalalternateearnedcredits);
            }

            if (data.totalalternaterequests != "") {
                setRequestOrCreditsText(totalAlternateRequests, data.totalalternaterequests);
            }

            updateRequestCountsInTabs(data.totalrequests, data.totalalternaterequests);

            const selectedBrowse = skyward.browse.browseList[selectedCoursesBrowseName];
            const selectedBrowseData = selectedBrowse.data;
            // Alternate browse might not be displayed depending on configuration
            const alternateBrowse = skyward.browse.browseList[alternateCourseBrowseName];
            const alternateBrowseData = alternateBrowse
                ? alternateBrowse.data
                : null;

            if (action == "RequestCourse")
            {
                const seekInfo = { seekId: courseID };
                if (isAlternateMode)
                {
                    skyward.browsePreferences.setPreferences(alternateBrowse, seekInfo);
                }
                else
                {
                    skyward.browsePreferences.setPreferences(selectedBrowse, seekInfo);
                }
            }
            else if (data.hasOwnProperty('linkedAlternates'))
            {
                skyward.controls.setValue($('#' + linkedAlternatesName), data.linkedAlternates);
                resetLinkedAlternatesUpdated();
            }

            updateAlternateRank(data.alternatesRank);

            var infoMessageToShow = "";
            if (data.informationmessage != "" && data.informationmessage != null && data.informationmessage != "undefined")
            {
                infoMessageToShow = data.informationmessage;
            }

            var linkedAlternates = getLinkedAlternates();
            var browsePromises = [];

            // These Browses only get passed StudentCourseRequestIDsToRemove and not AlternateStudentCourseRequestIDsToRemove
            // because each browse only shows one type of request.
            if (isAlternateMode) {
                var alternatePromise = skyward.browse.get(alternateCourseBrowseName, alternateBrowseData, {
                    CourseIDsToAdd: courseIDsToAdd, 
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd, 
                    StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, 
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates,
                });
                browsePromises.push(alternatePromise);
            }
            else 
            {
                var mainPromise = skyward.browse.get(selectedCoursesBrowseName, selectedBrowseData, {
                    CourseIDsToAdd: courseIDsToAdd, 
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd, 
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, 
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates,
                });

                browsePromises.push(mainPromise);

                if (skyward.browse.browseList[alternateCourseBrowseName]) {
                    // On mobile, both browses display and get refreshed at once.
                    // So alternates browse needs to use the combined list of IDs to remove in Order for the filter on Linked Primary to work
                    var altPromise = skyward.browse.get(alternateCourseBrowseName, alternateBrowseData, {
                        CourseIDsToAdd: courseIDsToAdd, 
                        AlternateCourseIDsToAdd: alternateCourseIDsToAdd, 
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank,
                        LinkedAlternates: linkedAlternates,
                    });
                    browsePromises.push(altPromise);
                }
            }

            $.whenAll(browsePromises).done(function() {
                showHideToolBarButtons();
                
                if (infoMessageToShow !== "") {
                    skyward.courserequest.showInformation(infoMessageToShow);
                }

                if (skyward.global.mobileAccess) {
                    skyward.courserequest.generateCourseFilter(true);
                }
            });
        };

        var removeRequestedCourse = function (courseID, courseIDSecurityHash, requestID, requestIDSecurityHash, requestSource, requestStatus, codeDescription)
        {
            resetMessages();
            var browse = isAlternateMode ? skyward.browse.browseList[alternateCourseBrowseName] : skyward.browse.browseList[selectedCoursesBrowseName];

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select a Selected Course to Remove");
                return;
            }

            if (IsScheduled(requestStatus))
            {
                skyward.courserequest.showError("The course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " has already been scheduled and cannot be removed");
                return;
            }

            if (IsAddedByOffice(requestSource) || IsAddedByImport(requestSource) || IsAddedByMassProcess(requestSource) || IsAddedByRecommendation(requestSource))
            {
                skyward.courserequest.showError("The request for course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " was added by the office and cannot be removed");
                return;
            }

            if (isAlternateMode)
            {
                var alternateRank = getSelectedBrowseRowData(browse, rankName);
            }

            var maximumCreditsValue = isAlternateMode ? skyward.controls.getValue($(maximumAlternateCredits)) : skyward.controls.getValue($(maximumCredits));
            var linkedAlternates = getLinkedAlternates();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RemoveRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    StudentCourseRequestID: requestID,
                    StudentCourseRequestID_SecurityHash: requestIDSecurityHash,
                    MaximumCredits: maximumCreditsValue,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank,
                    RankToRemove: alternateRank,
                    LinkedAlternates: linkedAlternates
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RemoveRequestedCourse", data, null, isAlternateMode);
                }
            });
        };

        var removeRequestedCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);

            if (skyward.global.mobileAccess)
            {
                isAlternateMode = rowData.IsAlternate || false;
            }

            removeRequestedCourse(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.StudentCourseRequestID,
                rowData.StudentCourseRequestIDSecurityHash, rowData.RequestSource, rowData.RequestStatus, rowData.CodeDescription);
        };

        var showPrimaryAlternatePopup = function (courseID, courseIDSecurityHash, courseCodeDescription, earnedCredits, subject)
        {
            var contents = $(".js-onlineRequestsPrimaryAlternatePopupContents").children().clone(false);

            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseCodeDescription"), courseCodeDescription);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseEarnedCredits"), earnedCredits);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupSubject"), subject);
            contents.find(".js-onlineRequestsAddPrimary").click(function ()
            {
                isAlternateMode = false;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });
            contents.find(".js-onlineRequestsAddAlternate").click(function ()
            {
                isAlternateMode = true;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });

            var dialog = skyward.modalLayer.showDialog("Add Course Request", contents, [{ text: "Close", icon: "Close", click: "close" }]);
        };

        var showAlternatePopup = function (courseID, courseIDSecurityHash, studentCourseRequestID, studentCourseRequestIDSecurityHash, courseDescription, courseCode, earnedCredits, subject, courseIDAlternateFor)
        {
            var contents = $(".js-onlineRequestsAlternatePopupContents").children().clone(false);

            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseDescription"), courseDescription);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseCode"), courseCode);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseEarnedCredits"), earnedCredits);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupSubject"), subject);

            var deferredBeforeShowContent = $.Deferred();

            var beforeCloseCallback = function () {
                if (!skyward.browse.browseList[alternateCourseBrowseName])
                {
                    return;
                }

                // on close, refresh the alternate browse to re-render RowData using the updated CoursesToAdd/LinkedAlternates
                var linkedAlternates = getLinkedAlternates();

                skyward.browse.get(
                    alternateCourseBrowseName,
                    skyward.browse.browseList[alternateCourseBrowseName].data,
                    {
                        CourseIDsToAdd: courseIDsToAdd,
                        AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank,
                        LinkedAlternates: linkedAlternates
                    });
            };

            var dialog = skyward.modalLayer.showDialog("Alternate Course Details", contents, [{ text: "Close", icon: "Close", click: "close" }], {

                beforeClose: beforeCloseCallback,
                beforeShowContentPromise: deferredBeforeShowContent
            });

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetAlternateInfoPopupEEL" + accessMode,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    CourseIDAlternateFor: courseIDAlternateFor,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestID: studentCourseRequestID,
                    StudentCourseRequestID_SecurityHash: studentCourseRequestIDSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    LinkedAlternates: getLinkedAlternates(),
                },
                success: function (html)
                {
                    var codeEELContainer = dialog.content.find(".js-onlineRequestsAlternatePopupEELContainer");
                    codeEELContainer.html(html);
                    dialog.container.css("height", "85%");
                    dialog.content.css("height", "100%");
                    dialog.content.css("max-height", "92%");
                    initCourseAltEELChangeHandlers();
                    deferredBeforeShowContent.resolve();
                }
            });
        };

        var showPrimaryAlternatePopupButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            return showPrimaryAlternatePopup(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.CodeDescription, rowData.EarnedCredits,
                rowData.Subject);
        };

        var showAlternateInfoPopupButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            return showAlternatePopup(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.StudentCourseRequestID, rowData.StudentCourseRequestIDSecurityHash, rowData.Description, rowData.CourseCode, rowData.EarnedCredits,
                rowData.Subject, rowData.CourseIDAlternateFor);
        };

        var showMyRequestsPopup = function () {
            var hiddenContentContainer = $(".js-myRequestsContent");
            var contents = hiddenContentContainer.children();

            var linkedAlternates = getLinkedAlternates();

            var selectedCoursesPromise = skyward.browse.get(
                selectedCoursesBrowseName,
                skyward.browse.browseList[selectedCoursesBrowseName].data,
                {
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                }
            );

            var alternateCoursesPromise = skyward.browse.get(
                alternateCourseBrowseName,
                skyward.browse.browseList[alternateCourseBrowseName].data,
                {
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                }
            );

            var beforeCloseCallback = function () {
                resetMessages();
                hiddenContentContainer.append(contents); // Move contents back to hidden container
            };

            var deferredBeforeShowContent = $.Deferred();

            $.whenAll([selectedCoursesPromise, alternateCoursesPromise]).then(function () {
                dialog.container.css("height", "95%");
                dialog.content.css("height", "100%");
                dialog.content.css("max-height", "92%");
                deferredBeforeShowContent.resolve();
            });

            var dialog = skyward.modalLayer.showDialog("My Requests", contents, [{ text: "Close", icon: "Close", click: "close" }], {
                beforeClose: beforeCloseCallback,
                beforeShowContentPromise: deferredBeforeShowContent
            });
        };


        var showMyRequestsButtonClick = function ()
        {
            resetMessages();
            showMyRequestsPopup();
        };

        var submitAndReviewButtonClick = function ()
        {
            showMyRequestsButtonClick();
            skyward.courserequest.submitCourseRequest();
        };

        // In skyward.courserequest.submitCourseRequest, ensure LinkedAlternates is sent in the AJAX data
        skyward.courserequest.submitCourseRequest = function ()
        {
            resetMessages();

            var linkedAlternates = getLinkedAlternates();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/SubmitRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                },
                success: function (data)
                {
                    if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
                    {
                        skyward.courserequest.showError(data.errormessage);
                        return;
                    }

                    skyward.courserequest.showConfirmation("The student course request changes have been successfully saved.");

                    updateInitialAlternateRank(data.alternatesRank);
                    clearStudentCourseRequestIDsToRemoveList();
                    clearCourseIDsToAddList();
                    
                    if (data.linkedAlternates) {
                        $('#' + linkedAlternatesName).val(data.linkedAlternates);
                    }
                    setInitialLinkedAlternates(data);
                    resetLinkedAlternatesUpdated();
                    showHideToolBarButtons();

                    skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, AlternateCourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank, LinkedAlternates: linkedAlternates });
                    if (skyward.browse.browseList[alternateCourseBrowseName])
                    {
                        skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, AlternateCourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank, LinkedAlternates: linkedAlternates });
                    }
                    refreshSelectedBrowseTotals();
                }
            });
        };

        skyward.courserequest.cancel = function ()
        {
            resetMessages();
            clearStudentCourseRequestIDsToRemoveList();
            clearCourseIDsToAddList();
            skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data);
            if (skyward.browse.browseList[alternateCourseBrowseName])
            {
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data);
            }
            refreshSelectedBrowseTotals();
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
            resetLinkedAlternates();
            resetLinkedAlternatesUpdated();
            showHideToolBarButtons();
        };

        skyward.courserequest.reorder = function ()
        {
            var browse = skyward.browse.browseList[alternateCourseBrowseName];
            var table = reorderElement.find(".sortableWrapper table");
            table.empty();

            var arrowColumnWidth = 150;

            if (skyward.global.mobileAccess)
            {
                arrowColumnWidth = 90;
            }

            var tbody = $("<tbody class='ui-sortable' />");

            var tHeader = $("<tr class='sortableHeaderRow'>");
            tHeader.append("<td class='sortableTableColumnHeader' style='width: " + arrowColumnWidth + "px; '></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 40px; '>Rank</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 150px;'>Course Description</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 85px; '>Course Code</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 150px;'>Alternate For</div></td></tr>");
            tbody.append(tHeader);

            var arrowButtonsHTML = "<td style='width:" + arrowColumnWidth + "px; height:33px;'>" +
                "<a class='button sortableUp js-sortableUp' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                "<svg class='buttonSvg svg arrowUp svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use href='#svg-ArrowUp'></use></svg></a>` +
                "<a class='button sortableDown js-sortableDown svgAnchor' alt='Move Down' href='javascript:void(0)' tabindex='0'>" +
                "<svg class='buttonSvg svg arrowDown svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use href='#svg-ArrowDown'></use></svg></a ></td > `;

            var selectedCourseDescriptionMap = (function ()
            {
                var map = {};
                var selectedBrowse = skyward.browse.browseList[selectedCoursesBrowseName];
                if (selectedBrowse && selectedBrowse.rowData)
                {
                    for (var i = 0; i < selectedBrowse.rowData.length; i++)
                    {
                        var rowData = selectedBrowse.rowData[i];
                        map[String(rowData[courseIDName])] = (rowData[courseDescriptionName] || "").trim();
                    }
                }
                return map;
            }());

            var getCourseDescriptionFromSelectedCourse = function (courseID)
            {
                if (courseID === null || courseID === undefined || courseID === "")
                {
                    return "";
                }
                return selectedCourseDescriptionMap[String(courseID)] || "";
            };

            var linkedAlternates = (function ()
            {
                var raw = getLinkedAlternates();
                if (raw !== null && raw !== undefined && raw !== "" && raw !== "undefined")
                {
                    try
                    {
                        var parsed = JSON.parse(raw);
                        return (parsed && typeof parsed === "object") ? parsed : {};
                    }
                    catch (e)
                    {
                        var details = "Raw LinkedAlternates: " + raw + "\n\n" + (e && (e.stack || e.message) ? (e.stack || e.message) : String(e));
                        skyward.error.reportException(new window.SkywardException("Unable to parse LinkedAlternates JSON.", details));
                    }
                }
                return {};
            }());

            var getMobileAlternateForCourseID = function (alternateRowData)
            {
                if (!alternateRowData)
                {
                    return null;
                }

                var studentCourseRequestID = alternateRowData[studentCourseRequestIDName];
                if (studentCourseRequestID !== null && studentCourseRequestID !== undefined && studentCourseRequestID !== "" &&
                    Object.prototype.hasOwnProperty.call(linkedAlternates, studentCourseRequestID))
                {
                    return linkedAlternates[studentCourseRequestID];
                }

                return alternateRowData.CourseIDAlternateFor;
            };

            // Returns the description text from a .courserequestlinkedprimaryeel element.
            // CodeEEL.cs renders the description input with class "codeEELDescription".
            var getCourseDescriptionFromAlternateForEEL = function (alternateForEEL, alternateRowData)
            {
                if (skyward.global.mobileAccess)
                {
                    var mobileCourseDescription = getCourseDescriptionFromSelectedCourse(getMobileAlternateForCourseID(alternateRowData));
                    if (mobileCourseDescription)
                    {
                        return mobileCourseDescription;
                    }
                }

                if (!alternateForEEL || !alternateForEEL.length)
                {
                    return "";
                }
                var selectedValueDisplayInput = alternateForEEL.find(".codeEELSelectedValueDisplayField").first();
                if (selectedValueDisplayInput && selectedValueDisplayInput.length)
                {
                    var selectedValueDisplay = (selectedValueDisplayInput.val() || "").trim();
                    if (selectedValueDisplay)
                    {
                        return selectedValueDisplay;
                    }
                }
                var descInput = alternateForEEL.find(".codeEELDescription").first();
                if (descInput && descInput.length)
                {
                    return (descInput.val() || "").trim();
                }
                return "";
            };

            var browseContainer = $("#" + alternateCourseBrowseName);
            var allAlternateForEELs = browseContainer.find(".courserequestlinkedprimaryeel");
            var counter = 1;
            for (var idx = 0; idx < browse.rowData.length; idx++)
            {
                var courseID = browse.rowData[idx][courseIDName];
                var studentCourseRequestID = browse.rowData[idx][studentCourseRequestIDName];
                var courseCode = browse.rowData[idx][courseCodeName];
                var description = browse.rowData[idx][courseDescriptionName];
                var rowEvenOdd = (counter) % 2 == 0 ? "even" : "odd";

                var rowID = courseID + "-";
                if (studentCourseRequestID.indexOf("-") == -1)
                {
                    rowID += studentCourseRequestID;
                }

                var row = $("<tr class='sortableRow " + rowEvenOdd + "' data-id='" + rowID + "'/>");

                var alternateForEEL = allAlternateForEELs.eq(idx);
                var alternateForEELCourseDescription = getCourseDescriptionFromAlternateForEEL(alternateForEEL, browse.rowData[idx]);

                row.append($(arrowButtonsHTML));
                row.append($("<td class='sortColumn browseDataCell'><div style='width:" + reorderColumnWidths[0] + "px;' class='sortableEllipsizingText'>" + counter++ + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[1] + "px;' class='sortableEllipsizingText'>" + description + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[2] + "px;' class='sortableEllipsizingText'>" + courseCode + "</div></td>"));
                row.append($("<td class='browseDataCell' />").append($("<div style='width:" + reorderColumnWidths[3] + "px;' class='sortableEllipsizingText' />").text(alternateForEELCourseDescription)));
                tbody.append(row);
            }

            table.append(tbody);

            skyward.sortable.initialize(reorderElement.html(), "Scheduling", "StudentCourseRequest", {}, skyward.courserequest.saveOrder);
        };

        skyward.courserequest.saveOrder = function (messageBox)
        {
            var list = [];
            $sortable = messageBox.content.find(".sortable").first();
            $sortable.find("tbody tr").each(function (index, element)
            {
                var id = $(element).data('id');
                list.push($(element).data('id'));
            });

            messageBox.close();

            if (list.length > 0)
            {
                updateAlternateRank(JSON.stringify(list));
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, AlternateCourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank, LinkedAlternates: getLinkedAlternates() });
                showHideToolBarButtons();
            }
        };

        var updateAlternateRank = function (ranks)
        {
            resetAlternateRange(ranks);
        };

        var updateInitialAlternateRank = function (newRank)
        {
            initialAlternateStudentCourseRequestRank = newRank;
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
        };

        var resetAlternateRange = function (ranks)
        {
            alternatesRank = ranks;
        };

        var refreshSelectedBrowseTotals = function ()
        {
            displayHighestMaximumCredits();
            updateTotalEarnedCreditsAndCounts();
        };

        var setRequestOrCreditsText = function (selector, valueToSet)
        {
            var control = $(selector);
            if (control.is(":input"))
            {
                skyward.controls.setValue(control, valueToSet);
            }
            else
            {
                control.text(valueToSet);
            }
        };

        var updateRequestCountsInTabs = function (totalRequests, totalAlternateRequests)
        {
            if (totalRequests !== undefined)
            {
                var myRequestsTab = $('.js-onlineRequestsTotalRequests').closest('#RequestedCourseWrapper').find('.js-tabbedContainerButton:contains(My Requests)');
                if (myRequestsTab && myRequestsTab.length)
                {
                    myRequestsTab.text("My Requests (" + totalRequests + ")");
                }
            }

            if (totalAlternateRequests !== undefined)
            {
                var alternatesTab = $('.js-onlineRequestsTotalRequests').closest('#RequestedCourseWrapper').find('.js-tabbedContainerButton:contains(Alternates)');

                if (alternatesTab && alternatesTab.length)
                {
                    alternatesTab.text("Alternates (" + totalAlternateRequests + ")");
                }
            }
        };

        var getRequestOrCreditsValue = function (selector)
        {
            var control = $(selector).eq(0);
            if (control.is(":input"))
            {
                return skyward.controls.getValue(control);
            }
            else
            {
                return control.text();
            }
        }

        var displayHighestMaximumCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetHighestMaximumCreditValues" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        useCreditsMaximum = data.UseCreditsMaximum;
                        useCourseRequestCountMaximum = data.UseCourseRequestCountMaximum;

                        if (data.UseCreditsMaximum)
                        {
                            if (data.MaximumCredits != "")
                            {
                                setRequestOrCreditsText(maximumCredits, data.MaximumCredits);
                            }
                            if (data.MaximumAlternateCredits != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCredits, data.MaximumAlternateCredits);
                            }
                        }
                        else
                        {
                            $(maximumCredits).parent().hide();
                            $(maximumAlternateCredits).parent().hide();
                        }

                        if (data.UseCourseRequestCountMaximum)
                        {
                            if (data.MaximumCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumCourseRequests, data.MaximumCourseRequests);
                            }
                            if (data.MaximumAlternateCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCourseRequests, data.MaximumAlternateCourseRequests);
                            }
                        }
                        else
                        {
                            $(maximumCourseRequests).parent().hide();
                            $(maximumAlternateCourseRequests).parent().hide();
                        }
                    }
                }
            });
        };

        var updateTotalEarnedCreditsAndCounts = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetTotalEarnedCredits" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.TotalEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalEarnedCredits, data.TotalEarnedCredits);
                        }

                        if (data.TotalAlternateEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalAlternateEarnedCredits, data.TotalAlternateEarnedCredits);
                        }

                        if (data.TotalRequests != "")
                        {
                            setRequestOrCreditsText(totalRequests, data.TotalRequests);
                        }

                        if (data.TotalAlternateRequests != "")
                        {
                            setRequestOrCreditsText(totalAlternateRequests, data.TotalAlternateRequests);
                        }

                        updateRequestCountsInTabs(data.TotalRequests, data.TotalAlternateRequests);
                    }
                }
            });
        };

        var normalizeAlternateRank = function (rank) {
            if (rank === "" || rank === null || rank === undefined || rank === "undefined" || rank === "[]") {
                return "";
            }
            return rank;
        };

        var showHideToolBarButtons = function ()
        {
            var dirtyClassName = "dirty";
            var changeClassName = "change ";

            if ((courseIDsToAdd != "" && courseIDsToAdd != null && courseIDsToAdd != "undefined") ||
                (studentCourseRequestIDsToRemove != "" && studentCourseRequestIDsToRemove != null && studentCourseRequestIDsToRemove != "undefined") ||
                (alternateCourseIDsToAdd != "" && alternateCourseIDsToAdd != null && alternateCourseIDsToAdd != "undefined") ||
                (alternateStudentCourseRequestIDsToRemove != "" && alternateStudentCourseRequestIDsToRemove != null && alternateStudentCourseRequestIDsToRemove != "undefined") ||
                (alternatesRank != initialAlternateStudentCourseRequestRank && normalizeAlternateRank(alternatesRank) !== normalizeAlternateRank(initialAlternateStudentCourseRequestRank)) ||
                linkedAlternatesChanged())
            {
                updateSubmitButtonDisplay(changeClassName, dirtyClassName);
                updateCancelButtonDisplay(changeClassName, dirtyClassName);
                skyward.changeTracking.overrideGlobalDirtyState(true);
            }
            else
            {
                updateSubmitButtonDisplay(dirtyClassName, changeClassName);
                updateCancelButtonDisplay(dirtyClassName, changeClassName);
                skyward.changeTracking.overrideGlobalDirtyState(false);
            }

            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var updateSubmitButtonDisplay = function (removeClass, addClass)
        {
            submitButton.removeClass(removeClass);
            submitButton.addClass(addClass);
        };

        var updateCancelButtonDisplay = function (removeClass, addClass)
        {
            cancelButton.removeClass(removeClass);
            cancelButton.addClass(addClass);
        };

        //helper functions
        var clearStudentCourseRequestIDsToRemoveList = function ()
        {
            studentCourseRequestIDsToRemove = "";
            studentCourseRequestIDsToRemoveSecurityHash = "";
            alternateStudentCourseRequestIDsToRemove = "";
            alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        };

        var clearCourseIDsToAddList = function ()
        {
            courseIDsToAdd = "";
            courseIDsToAddSecurityHash = "";
            alternateCourseIDsToAdd = "";
            alternateCourseIDsToAddSecurityHash = "";
        };

        var updateStudentCourseRequestIDsToRemoveList = function (data)
        {
            var hasStudentCourseRequestIDsToRemove = data.hasOwnProperty("studentCourseRequestIDsToRemove");
            var hasAlternateStudentCourseRequestIDsToRemove = data.hasOwnProperty("alternateStudentCourseRequestIDsToRemove");

            if (!hasStudentCourseRequestIDsToRemove && !hasAlternateStudentCourseRequestIDsToRemove)
            {
                clearStudentCourseRequestIDsToRemoveList();
            }

            if (hasStudentCourseRequestIDsToRemove)
            {
                studentCourseRequestIDsToRemove = data.studentCourseRequestIDsToRemove
                studentCourseRequestIDsToRemoveSecurityHash = data.studentCourseRequestIDsToRemoveSecurityHash;
            }

            if (hasAlternateStudentCourseRequestIDsToRemove)
            {
                alternateStudentCourseRequestIDsToRemove = data.alternateStudentCourseRequestIDsToRemove;
                alternateStudentCourseRequestIDsToRemoveSecurityHash = data.alternateStudentCourseRequestIDsToRemoveSecurityHash;
            }
        };

        var updateCourseIDsToAddList = function (data)
        {
            var hasCourseIDsToAdd = data.hasOwnProperty("courseIDsToAdd");
            var hasAlternateCourseIDsToAdd = data.hasOwnProperty("alternateCourseIDsToAdd");

            if (!hasCourseIDsToAdd && !hasAlternateCourseIDsToAdd)
            {
                clearCourseIDsToAddList();
            }

            if (hasCourseIDsToAdd)
            {
                courseIDsToAdd = data.courseIDsToAdd
                courseIDsToAddSecurityHash = data.courseIDsToAddSecurityHash;
            }

            if (hasAlternateCourseIDsToAdd)
            {
                alternateCourseIDsToAdd = data.alternateCourseIDsToAdd;
                alternateCourseIDsToAddSecurityHash = data.alternateCourseIDsToAddSecurityHash;
            }
        };

        var getSelectedBrowseRowPrimaryKey = function (browse)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.primaryKeys[browse.currentRow];
        };

        function getSelectedBrowseRowData(browse, key)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.rowData[browse.currentRow][key];
        }

        var IsAddedByOffice = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "o")
            {
                return true;
            }

            return false;
        };

        var IsAddedByRecommendation = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "r")
            {
                return true;
            }

            return false;
        };

        var IsAddedByImport = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "i")
            {
                return true;
            }

            return false;
        };

        var IsAddedByMassProcess = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "m")
            {
                return true;
            }

            return false;
        };

        var IsScheduled = function (requestStatus)
        {
            if (requestStatus == null || requestStatus == "undefined")
            {
                return false;
            }

            if (requestStatus.toLowerCase() === "s")
            {
                return true;
            }

            return false;
        };

        skyward.courserequest.generateCourseFilter = function (forceRefresh)
        {
            var availableCoursesContainsValue = $(availableCoursesContains);

            var containsValue = skyward.controls.getValue(availableCoursesContainsValue);

            if (containsValue != previousContainsString || forceRefresh)
            {
                if (containsValue != previousContainsString)
                {
                    previousContainsString = containsValue;
                }

                var postData = { CourseCodeContains: containsValue, DescriptionContains: containsValue, SubjectDescriptionContains: containsValue };

                if (skyward.global.mobileAccess)
                {
                    $.extend(postData, {
                        CourseIDsToAdd: JSON.stringify(JSON.parse(courseIDsToAdd || "[]")),
                        AlternateCourseIDsToAdd: JSON.stringify(JSON.parse(alternateCourseIDsToAdd || "[]")),
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank
                    });
                }

                skyward.browse.get(availableCoursesBrowseName, skyward.browse.browseList[availableCoursesBrowseName].data, postData);
            }
        };

        var combineStringifiedArrays = function (array1, array2)
        {
            if (array1 === null || array1 === undefined || array1 === "")
            {
                array1 = "[]";
            }

            if (array2 === null || array2 === undefined || array2 === "")
            {
                array2 = "[]";
            }

            var parsed1 = JSON.parse(array1);
            var parsed2 = JSON.parse(array2);

            return JSON.stringify(parsed1.concat(parsed2));
        };

        var tabClickHandler = function (event)
        {
            if (event.target.firstChild.data && event.target.firstChild.data.indexOf(isAlternateTabName) !== -1)
            {
                isAlternateMode = true;
            }
            else
            {
                isAlternateMode = false;
            }
        };

        //Content Message Area -- cloned like code from skyward.ui.contentMessageArea.ts
        skyward.courserequest.showConfirmation = function (message)
        {
            requestContentMessageArea.setConfirmationMessage(message);
            requestContentMessageArea.showConfirmation();
            myRequestsPopupRequestContentMessageArea.setConfirmationMessage(message);
            myRequestsPopupRequestContentMessageArea.showConfirmation();
        };

        skyward.courserequest.showInformation = function (message)
        {
            requestContentMessageArea.setInformationMessage(message);
            requestContentMessageArea.showInformation();
            myRequestsPopupRequestContentMessageArea.setInformationMessage(message);
            myRequestsPopupRequestContentMessageArea.showInformation();
        };

        skyward.courserequest.showError = function (message)
        {
            requestContentMessageArea.setErrorMessage(message);
            requestContentMessageArea.showError();
            myRequestsPopupRequestContentMessageArea.setErrorMessage(message);
            myRequestsPopupRequestContentMessageArea.showError();
        };

        skyward.courserequest.showWarning = function (message)
        {
            requestContentMessageArea.setWarningMessage(message);
            requestContentMessageArea.showWarning();
            myRequestsPopupRequestContentMessageArea.setWarningMessage(message);
            myRequestsPopupRequestContentMessageArea.showWarning();
        };

        var resetMessages = function ()
        {
            requestContentMessageArea.resetMessageContent(true, true, true);
            myRequestsPopupRequestContentMessageArea.resetMessageContent(true, true, true);
        };

        var contentMessageAreas = {};
        var currentContentMessageAreaKey = 0;

        skyward.courserequest.getContentMessageArea = function (container)
        {
            if (!container || !container.data())
            {
                return getStubbedContentMessageAreaObject();
            }

            var contentMessageAreaKey = container.data().contentMessageAreaKey;

            if (contentMessageAreaKey != undefined && contentMessageAreas.hasOwnProperty(contentMessageAreaKey))
            {
                return contentMessageAreas[contentMessageAreaKey];
            }

            var contentMessageArea = container.find('.contentMessageArea').first();

            if (contentMessageArea && contentMessageArea.length > 0)
            {
                var cmaObject = getContentMessageAreaObject(contentMessageArea);
                contentMessageAreas[currentContentMessageAreaKey] = cmaObject;
                container.data('content-message-area-key', currentContentMessageAreaKey);
                currentContentMessageAreaKey++;
                return cmaObject;
            }
            else
            {
                return null;
            }
        };

        /**
         * Returns an minimal object that mimics the structure of those returned by getContentMessageAreaObject
         */
        var getStubbedContentMessageAreaObject = function ()
        {
            var contentMessageAreaObject = {};
            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return $("<div>");
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function () { };
            contentMessageAreaObject.setConfirmationMessage = function () { };
            contentMessageAreaObject.setErrorMessage = function () { };
            contentMessageAreaObject.setWarningMessage = function () { };

            contentMessageAreaObject.showConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return 0;
            };

            return contentMessageAreaObject;
        };

        var getContentMessageAreaObject = function (contentMessageAreaElement)
        {
            var contentMessageAreaObject = {};

            var contentMessageArea = contentMessageAreaElement;
            var errorMessage = getMessageObject(contentMessageArea, '.cmaErrorMessage');
            var warningMessage = getMessageObject(contentMessageArea, '.cmaWarningMessage');
            var confirmationMessage = getConfirmationMessageObject(contentMessageArea, '.cmaConfirmationMessage');
            var informationMessage = getMessageObject(contentMessageArea, '.cmaInformationMessage');

            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return contentMessageArea;
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                confirmationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                errorMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                informationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                warningMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function (isResetError, isResetWarning, isResetInformation)
            {
                if (isResetError)
                {
                    errorMessage.reset();
                }
                if (isResetWarning)
                {
                    warningMessage.reset();
                }
                if (isResetInformation)
                {
                    informationMessage.reset();
                }
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function (message)
            {
                informationMessage.setMessage(message);
                informationMessage.show();
            };
            contentMessageAreaObject.setConfirmationMessage = function (message)
            {
                confirmationMessage.setMessage(message);
                confirmationMessage.show();
            };
            contentMessageAreaObject.setErrorMessage = function (message)
            {
                errorMessage.setMessage(message);
                errorMessage.show();
            };
            contentMessageAreaObject.setWarningMessage = function (message)
            {
                warningMessage.setMessage(message);
                warningMessage.show();
            };

            contentMessageAreaObject.showConfirmation = function ()
            {
                if (confirmationMessage.hasValue)
                {
                    confirmationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                if (errorMessage.hasValue)
                {
                    errorMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                if (informationMessage.hasValue)
                {
                    informationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                if (warningMessage.hasValue)
                {
                    warningMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return contentMessageArea.outerHeight(true);
            };

            return contentMessageAreaObject;
        };

        var getConfirmationMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                // Try to fallback to message object higher up the DOM hierarchy
                messageElement = contentMessageArea.parent().find(className);

                if (messageElement.length == 0)
                {
                    return messageObject;
                }
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');

            messageObject = setConfirmationMessageFunctions(messageObject, messageContainer);

            messageObject.message.off('click');

            return messageObject;
        };

        var setConfirmationMessageFunctions = function (object, container)
        {
            var base =
            {
                makeHidden: object.makeHidden,
                show: object.show,
                hide: object.hide,
                isVisible: object.isVisible
            };

            object.hide = function ()
            {
                object.message.animate({ 'opacity': 0 },
                    {
                        complete: function ()
                        {
                            base.hide();
                        }
                    });
                return object;
            };
            object.show = function ()
            {
                base.show();
                object.message.animate({ 'opacity': 1 },
                    {
                        complete: function ()
                        {
                            window.setTimeout(function ()
                            {
                                object.reset();
                                container.trigger("SaveAnimationRedirect");
                            }, 3000);
                        }
                    });
                return object;
            };
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                var cmaMessage = container.find(".cmaMessageText");
                if (cmaMessage.length > 0)
                {
                    cmaMessage.text(message);
                }
                else
                {
                    container.text(message);
                }
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            return object;
        };

        var getMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                return messageObject;
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');
            messageObject = setErrorWarningInformationFunction(messageObject, messageContainer);
            return messageObject;
        };

        var setErrorWarningInformationFunction = function (object, container)
        {
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                container.text(message);
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            setAdditionalInformationBubbleClick(object);
            return object;
        };

        var setAdditionalInformationBubbleClick = function (messageObject)
        {
            messageObject.message.off('click').click(function ()
            {
                var dialog = skyward.modalLayer.showDialog('Additional Information', messageObject.message.find('.cmaMessage').text(), [{ text: 'Close', icon: 'Close' }],
                    {
                        anchorTo: messageObject.message.find('.svg')
                    });
            });
        };

        var getBaseMessage = function ()
        {
            var baseMessage = {};

            baseMessage.message = undefined;

            baseMessage.show = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.removeClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.hide = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.addClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.reset = function ()
            {
                return baseMessage.hide();
            };

            return baseMessage;
        };

        skyward.courserequest.showLegend = function (button)
        {
            skyward.modalLayer.showDialog("Course Requests Legend", $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/OnlineRequestsGetLegend",
                type: "GET",
                dataType: "viewparthtml"
            }), [{ text: "Close", icon: "Close", click: "close" }], { anchorTo: $(button) });
        };

        function getLinkedAlternates()
        {
            return skyward.controls.getValue($('#' + linkedAlternatesName));
        }

        function getInitialLinkedAlternates()
        {
            return skyward.controls.getValue($('#' + initialLinkedAlternatesName));
        }

        function setInitialLinkedAlternates (data)
        {
            var valueToSet;
            if (data && data.linkedAlternates)
            {
                valueToSet = data.linkedAlternates;
            }
            else
            {
                valueToSet = getLinkedAlternates()
            }
            skyward.controls.setValue($('#' + initialLinkedAlternatesName), valueToSet);
        }

        function resetLinkedAlternates()
        {
            skyward.controls.setValue($('#' + linkedAlternatesName), getInitialLinkedAlternates());
        }

        function linkedAlternatesChanged()
        {
            const linkedAlternatesUpdated = skyward.controls.getValue($('#' + linkedAlternatesUpdatedName));
            if (!linkedAlternatesUpdated || linkedAlternatesUpdated.length === 0 || linkedAlternatesUpdated === "undefined" || linkedAlternatesUpdated == 'false')
            {
                return false;
            }
            return true;
        }

        function resetLinkedAlternatesUpdated()
        {
            skyward.controls.setValue($('#' + linkedAlternatesUpdatedName), false);
        }

        function initCourseAltEELChangeHandlers()
        {
            // Bind to both the browse-specific selector and a global id-based selector.
            // This covers mobile where the CourseAlt EEL may be rendered outside of the browse container.
            var courseAltSelector = "#" + alternateCourseBrowseName + " [id^='CourseAltID-'] .codeEELValue, [id^='CourseAltID-'] .codeEELValue";
            $("body").off("change", courseAltSelector)
                .on("change", courseAltSelector, courseAltEELChange);
        };

        function courseAltEELChange()
        {
            var triggeringControl = $(this);
            var eel = triggeringControl.closest('.codeEEL')
            const courseID = skyward.controls.getValue(triggeringControl);
            var alternateID = eel.data('courseid');
            var studentCourseRequestID = eel.data("studentcourserequestid");
            // Prefer rowData lookup over DOM data-* (mobile may not have it)
            var rowId = triggeringControl.closest("td").data("row");
            var browse = skyward.browse.browseList[alternateCourseBrowseName];

            if (browse && browse.rowData && rowId !== undefined && browse.rowData[rowId] && browse.rowData[rowId][studentCourseRequestIDName] !== undefined) {
                studentCourseRequestID = browse.rowData[rowId][studentCourseRequestIDName];
            }
            var linkedAlternates = getLinkedAlternates();
            var initialLinkedAlternates = getInitialLinkedAlternates();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/UpdateAlternateEEL" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,

                    CourseID: courseID,
                    AlternateID: alternateID,
                    StudentCourseRequestID: studentCourseRequestID,

                    LinkedAlternates: linkedAlternates,
                    InitialLinkedAlternates: initialLinkedAlternates,

                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash
                },
                success: function (data) {
                    if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined") {
                        skyward.courserequest.showError(data.errormessage);
                        return;
                    }
                    skyward.controls.setValue($('#' + linkedAlternatesName), data.linkedAlternates);
                    skyward.controls.setValue($('#' + linkedAlternatesUpdatedName), data.linkedAlternatesUpdated);

                    updateCourseIDsToAddList(data);
                    showHideToolBarButtons();
                }
            });
        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
)